import React, { useState } from "react";
import { IntlProvider } from "react-intl";
import EnglishGB from "../lang/en-GB.json";
import EnglishUS from "../lang/en-US.json";
import Deutsch from "../lang/de.json";
import Welsh from "../lang/cy.json";
import French from "../lang/fr.json";
import Finnish from "../lang/fi.json";
import Dutch from "../lang/nl.json";
import Spanish from "../lang/es.json";
import Italian from "../lang/it.json";

export const Context = React.createContext();

const local = navigator.language;

let lang = EnglishGB;

if (local === "en-US") {
  lang = EnglishUS;
} else if (local === "de-DE") {
  lang = Deutsch;
} else if (local === "cy-CY") {
  lang = Welsh;
} else if (local === "fr-FR") {
  lang = French;
} else if (local === "fi-FI") {
  lang = Finnish;
} else if (local === "nl-NL") {
  lang = Dutch;
} else if (local === "es-ES") {
  lang = Spanish;
} else if (local === "it-IT") {
  lang = Italian;
}

const LanguageContext = (props) => {
  const [locale, setLocale] = useState(local);
  const [messages, setMessages] = useState(lang);

  function selectLanguage(e) {
    const newLocale = e;
    setLocale(newLocale);

    if (newLocale === "en-US") {
      setMessages(EnglishUS);
    } else if (newLocale === "de-DE") {
      setMessages(Deutsch);
    } else if (newLocale === "cy-CY") {
      setMessages(Welsh);
    } else if (newLocale === "fr-FR") {
      setMessages(French);
    } else if (newLocale === "fi-FI") {
      setMessages(Finnish);
    } else if (newLocale === "nl-NL") {
      setMessages(Dutch);
    } else if (newLocale === "es-ES") {
      setMessages(Spanish);
    } else if (newLocale === "it-IT") {
      setMessages(Italian);
    } else {
      setMessages(EnglishGB);
    }
  }

  return (
    <Context.Provider
      value={{
        locale,
        selectLanguage,
        lang: locale.split("-")[0],
        messages: messages,
      }}
    >
      <IntlProvider
        messages={messages}
        locale={locale}
      >
        {props.children}
      </IntlProvider>
    </Context.Provider>
  );
};

export default LanguageContext;
